var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ImagesCarouselBaseComponent } from '../../../common-theme/base-components/shared/images-carousel-base/images-carousel-base.component';
var HomepageCarouselComponent = /** @class */ (function (_super) {
    __extends(HomepageCarouselComponent, _super);
    function HomepageCarouselComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.animateTitle = false;
        return _this;
    }
    return HomepageCarouselComponent;
}(ImagesCarouselBaseComponent));
export { HomepageCarouselComponent };



// WEBPACK FOOTER //
// ./src/app/shared/components/homepage-carousel/homepage-carousel.component.ts.pre-build-optimizer.js